import React, {Fragment} from "react";
import { BulkDeleteButton } from "react-admin";

const CustomBulkActionButtons = props => (
    <Fragment>
        <BulkDeleteButton {...props} undoable={false}/>
    </Fragment>
);

export default CustomBulkActionButtons;